selectIsGiftCompatible